import { Injectable, EventEmitter } from '@angular/core';
import { ServeridentificationExpressionModel } from 'app/app-model/server-identification/server-identification.model';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IdentificationExpressionService {
    modified: Subject<any> = new Subject();
}